<template>
  <div :class="isDataFromPOComponent ? 'invoice-tab-table-container':'container'">
    <alert-message v-if="errorMessage"></alert-message>
    <loading-spinner v-if="invoiceDashboardDataIsLoading"></loading-spinner>
    <div :class="!isDataFromPOComponent ? 'mt-4':null" v-show="!invoiceDashboardDataIsLoading">
      <div class="pt-4">
        <div v-if="noInvoicesDataFetched">
          <span class="main-title ml-0 pl-0">{{noRecordsMessage}}</span><br>
          <span v-html="FORM_LABELS.ACCOUNTS_PAYABLE_HELP_TEXT"/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-2 mt-2" v-if="showInvoiceCategoryNavigation">
            <all-invoices-categories @onInvoiceCategorySelected="onInvoiceCategorySelected" />
        </div>
        <div class="pl-lg-2 col-12 mt-0 pt-0" :class="isDataFromPOComponent ? null : 'col-lg-10'">

          <div ref="invoiceTrackerRecords" v-if="validateCurrentRoute(CONSTANTS.INVOICES_TAB_ROUTES.SUBMITTED_INVOICES) && showInvoiceTracker">
            <user-invoice-submission-tracker/>
          </div>

          <div  class="mb-5" v-if="validateCurrentRoute(CONSTANTS.INVOICES_TAB_ROUTES.INVOICES) && showInvoices">
            <div class="header">
              <div :class="isDataFromPOComponent ? 'po-modal-title':'main-title mb-2'" class="align-with-table">{{CONSTANTS.INVOICES_COMPONENT_TITLE_HEADER}}</div>
            </div>
            <div class="mb-2 pb-2 align-with-table" v-if="viewingAPUserDataFor && !isDataFromPOComponent">Showing results for <span class="font-weight-bold">{{viewingAPUserDataFor}}</span></div>
            <div v-if="this.viewingAPUserDataFor && !isDataFromPOComponent" class="align-with-table mb-2">
              <a class="solution-link" @click="resetViewAndGetInvoices">View your invoices/purchase orders </a>
            </div>
            <div v-if="!isDataFromPOComponent"  class="row d-block px-4 py-2">
              <div class="font-italic loading-filters"><a @click="showPoFilterFAQModal('invoices')" class="solution-link">Learn more</a> about the data that you are eligible to view.</div>
            </div>
            <invoice-filters
                v-if="!isDataFromPOComponent"
                ref="invoiceFilters"
                :invoice-dashboard-data-is-loading="invoiceDashboardDataIsLoading"
                @onResetInvoiceFilterPreferences="resetInvoiceTableUserPreferences"
                @onFilterListUpdated="updateInvoicesFilteredList($event)"
                @onFiltersSelected="updateFiltersSelected($event)"
            />
            <div class="row no-gutters mt-3" v-if="!invoiceDashboardDataIsLoading">
              <vue-good-table
                  :columns="formattedColumns"
                  :rows="invoicesList"
                  class="table-word-wrap invoice-table"
                  :pagination-options="paginationConfig"
                  :sort-options="invoicesSortConfig"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-per-page-change="onPerPageChange"
                  ref="invoices"
                  :key="componentKey"
                  :class="isLoading ? 'd-none':''"
              >

                <div slot="emptystate">{{ noRecordsMessage }}</div>

                <template slot="table-column" slot-scope="props">
                  <invoices-table-header :headerProps="props" @onUserSortClicked="userSortClicked" />
                </template>

                <template slot="table-row" slot-scope="props" >

            <span v-if="props.column.field === 'poNumber' &&  props.row.multiplePOCount>1">
              <span class="solution-link" @click="onInvoiceClicked(props.row)">Multiple PO</span>
             </span>
                  <span v-else-if="props.column.field === 'poNumber' && props.row.poNumber !== 'NON-PO' && !props.row.multiplePOCount">
              <span class="solution-link" @click="onPOClicked(props.row.poNumber)">{{props.row.poNumber}}</span>
            </span>
                  <span v-else-if="props.column.field === 'poNumber' && props.row.poNumber === 'NON-PO'">
              <span>N/A</span>
            </span>
                  <span v-else-if="props.column.field === 'invoiceNumber'">
              <span class="solution-link" @click="onInvoiceClicked(props.row)">{{props.row.invoiceNumber}}</span>
           </span>
                  <span v-else-if="props.column.field === 'formattedInvoiceStatus'">
              <span v-html="props.row.formattedInvoiceStatus"
                    :data-original-title="props.row.formattedInvoiceStatus"
                    data-toggle="tooltip"
                    data-container="body"
                    rel="tooltip"
                    data-placement="right"
                    data-html="true"
              >
                              {{props.row.formattedInvoiceStatus}}
              </span>
            </span>
                  <span v-else-if="props.column.field === CONSTANTS.PAYMENT_DATE_FIELD" >
              <span v-html="props.row.paymentDate"
                    :data-original-title="props.row.paymentDate"
                    data-toggle="tooltip"
                    data-container="body"
                    rel="tooltip"
                    data-placement="right"
                    data-html="true"
              >
              </span>
            </span>
                  <span v-else-if="props.column.field=== 'docType'">
              <span v-if="isCopyEligible(props.row.docType, props.row.channelId)">
                <span class="solution-link" @click="onInvoiceClicked(props.row)">View</span> |
                <span class="solution-link" @click="copyInvoiceData(props)">Copy</span>
              </span>
              <span v-else>
                <span class="solution-link" @click="onInvoiceClicked(props.row)">View</span>
              </span>
            </span>
                </template>
              </vue-good-table>

              <div v-if="!isDataFromPOComponent" class="row d-block pl-4 pt-4">
                <div class="font-italic" v-html="FORM_LABELS.INVOICE_18_MONTHS_DESCRIPTION"/>
              </div>
            </div>
          </div>

          <div v-if="validateCurrentRoute(CONSTANTS.INVOICES_TAB_ROUTES.DRAFTS) && showInvoiceDrafts" ref="invoicesDrafts">
            <user-invoice-drafts />
          </div>

          <div v-if="!noInvoicesDataFetched">
            <div v-if="validateCategoryRecords && !invoiceDashboardDataIsLoading" class="font-italic">You dont have any records for the requested category. Please choose a different category to view your invoices.<br><br><span v-html="FORM_LABELS.ACCOUNTS_PAYABLE_HELP_TEXT"/></div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/store/constants";
import { VueGoodTable } from "vue-good-table";
import AlertMessage from "@/components/AlertMessage";
import LoadingSpinner from "@/components/LoadingSpinner";
import InvoicesAndPOMixin from "@/mixins/InvoicesAndPOMixin";
import { mapGetters,mapMutations,mapActions } from "vuex"
import filters from "@/filters/filter"
import UserInvoiceDrafts from "@/components/InvoiceAndPurchaseOrders/UserInvoiceDrafts";
import swal from "sweetalert2";
import InvoicesPOFiltersMixin from "../../mixins/InvoicesPOFiltersMixin";
import InvoiceFilters from "@/components/InvoiceAndPurchaseOrders/InvoiceFilters";
import VGT_COLUMNS from "@/store/vgtColumns";
import InvoicesTableHeader from "@/components/InvoiceAndPurchaseOrders/InvoicesTableHeader";
import UserInvoiceSubmissionTracker from "./UserInvoiceSubmissionTracker";
import AllInvoicesCategories from "../AllInvoicesCategories"
import FORM_LABELS from "@/store/FormLabels";


export default {
  name: "Invoices",
  components: {
    AllInvoicesCategories,
    InvoicesTableHeader,UserInvoiceSubmissionTracker,
    InvoiceFilters, VueGoodTable ,AlertMessage, LoadingSpinner, UserInvoiceDrafts},
  mixins: [InvoicesAndPOMixin,InvoicesPOFiltersMixin],
  filters,
  props: ["invoices"],
  watch: {
    async currentUser() {
      this.setFormattedInvoices(null)
      await this.updateImpersonationData()
    },
    viewingAPUserDataFor() {
      this.clearInvoiceFilters()
      this.invoicesFiltersSelected = false
      this.invoicesFilteredList = null
    },
    formattedInvoices(){
      this.clearInvoiceFilters()
    }
  },
  data() {
    return {
      invoiceDashboardIsLoading: false,
      invoicesFilteredList: null,
      columns: VGT_COLUMNS.INVOICES_TABLE_COLUMNS,
      showSpinner:true,
      invoicesFiltersSelected:false,
      noRecordsMessage: "You don't have any invoices to display.",
      //Maintain a flag in session so that Invoices component is loaded via PODetailModal component, do not persist pagination, sorting, filtering
      isDataFromPOComponent: false,
      componentKey: 0,
      poBasedFormType: CONSTANTS.PO_BASED_API_FORM_TYPE,
      nonPOBasedFormType: CONSTANTS.NON_PO_BASED_API_FORM_TYPE,
      channelId: CONSTANTS.ALLOWED_CHANNEL_FOR_COPY,
      isCopyEligible: VGT_COLUMNS.isCopyEligible,
      FORM_LABELS: FORM_LABELS,
    }
  },
  computed: {
    ...mapGetters(["formattedInvoices","errorMessage", "isLoading","currentUser","purchaseOrdersFormattedList", "invoicesTableUserPreferences","viewingAPUserDataFor","invoiceDraftRecords","isAPAdmin","isInvoicesAndDraftsCached","invoiceSubmissionStatusRecords",'invoiceCategoryAccessMethods']),
    formattedColumns() {
      if(this.viewingAPUserDataFor) {
        return this.columns.filter(allColumns => allColumns.field !== 'docType')
      }
      return this.columns
    },
    showInvoiceTracker(){
      return !this.isDataFromPOComponent && this.invoiceSubmissionStatusRecords && this.invoiceSubmissionStatusRecords.length > 0 && !this.invoiceDashboardDataIsLoading
    },
    showInvoices(){
      return !this.invoiceDashboardDataIsLoading && this.formattedInvoices && this.formattedInvoices.length > 0
    },
    noInvoicesDataFetched() {
      return !this.invoiceDashboardDataIsLoading && !(this.invoicesList && this.invoicesList.length > 0) && !(this.invoiceSubmissionStatusRecords && this.invoiceSubmissionStatusRecords.length > 0)  && !(this.invoiceDraftRecords && this.invoiceDraftRecords.length > 0)
    },
    validateCategoryRecords(){
      return this.isInvoiceRouteWithNoData() || this.isTrackerRouteWithNoData() || this.isDraftRouteWithNoData()
    },
    showInvoiceCategoryNavigation(){
      return Object.values(CONSTANTS.INVOICES_TAB_ROUTES).includes(this.$route.params.invoiceCategory)
    },
    showInvoiceDrafts(){
      return !this.viewingAPUserDataFor && !this.isDataFromPOComponent && this.invoiceDraftRecords && this.invoiceDraftRecords.length > 0 && !this.invoiceDashboardDataIsLoading
    },
    invoicesSortConfig() {
      return { enabled: true, initialSortBy: { field: this.invoicesTableUserPreferences.sort && this.invoicesTableUserPreferences.sort.field ? this.invoicesTableUserPreferences.sort.field : 'invoiceDate', type: this.invoicesTableUserPreferences.sort && this.invoicesTableUserPreferences.sort.type ? this.invoicesTableUserPreferences.sort.type : 'desc'}}
    },
    paginationConfig() {
      if(this.isDataFromPOComponent) {
        return { enabled: this.paginationEnabled, setCurrentPage: 1, perPage: 5 }
      } else {
        return { enabled: this.paginationEnabled, setCurrentPage: this.invoicesTableUserPreferences.pagination.currentPage, perPage: this.invoicesTableUserPreferences.pagination.currentPerPage }
      }
    },
    paginationEnabled() {
      if(this.isDataFromPOComponent) {
        return this.invoicesList&&this.invoicesList.length > 5
      } else {
        return this.invoicesList&&this.invoicesList.length > CONSTANTS.PAGINATION_THRESHOLD
      }
    },
    invoicesList() {
       //this.invoices is a prop that the component accepts, we use Invoices.vue as a component in PoDetailModal.vue
      this.setDataFromPOComponent()
       if(this.invoices) {
         return this.invoices
       }
       else if(this.invoicesFilteredList && this.invoicesFilteredList.length > 0 || this.invoicesFiltersSelected) {
         return this.invoicesFilteredList
       }
       else {
         return this.formattedInvoices
       }
    },
    invoiceDashboardDataIsLoading() {
      return this.isLoading || this.invoiceDashboardIsLoading
    }
  },
  created() {
    if (this.invoiceCategoryAccessMethods.clicked === false && this.invoiceCategoryAccessMethods.isAccessedViaDeeplink === true){
      this.validateForDeepLinkAccess()
    }else if (this.isInvoicesAndDraftsCached){
      //This check is for ensuring we refresh the dashboard , when a new draft via Invoice dashboard is saved and toggled to draft-invoices route on the popup modal.
      this.initializeComponent()
    }
  },
  methods: {
    ...mapMutations(["setFormattedInvoices","setInvoicesTableUserPreferences","setPrevRoute","setIsFormDataLoaded","setViewingAPUserDataFor","setIsInvoicesAndDraftsCached"]),
    ...mapActions(["fetchInvoiceDashboardData","deleteInvoiceDraftById"]),
    isInvoiceRouteWithNoData(){
      return this.formattedInvoices && this.formattedInvoices.length === 0 && this.$route.params.invoiceCategory === CONSTANTS.INVOICES_TAB_ROUTES.INVOICES
    },
    isTrackerRouteWithNoData(){
      return this.invoiceSubmissionStatusRecords && this.invoiceSubmissionStatusRecords.length === 0 && this.$route.params.invoiceCategory === CONSTANTS.INVOICES_TAB_ROUTES.SUBMITTED_INVOICES
    },
    isDraftRouteWithNoData(){
      return this.invoiceDraftRecords && this.invoiceDraftRecords.length === 0 && this.$route.params.invoiceCategory === CONSTANTS.INVOICES_TAB_ROUTES.DRAFTS
    },
    onInvoiceCategorySelected(category){
      this.invoiceCategoryAccessMethods.clicked = true
      this.invoiceCategoryAccessMethods.isAccessedViaDeeplink = false
      this.validateForDeepLinkAccess(category)
    },
    validateForDeepLinkAccess(category){
      // The below condition checks for conditions when the dashboard is accessed via deeplink, toggled from created()
      if(!(Object.values(CONSTANTS.INVOICES_TAB_ROUTES).includes(this.$router.currentRoute.params.invoiceCategory)) && !(this.$route.name === 'Filtered POs')) {
        const notFoundURL = CONSTANTS.EH_URL + '/404'
        window.location.replace(notFoundURL)
      }else if (category === undefined && (Object.values(CONSTANTS.INVOICES_TAB_ROUTES).includes(this.$router.currentRoute.params.invoiceCategory))) {
        this.initializeComponent()
      }
    },
    validateCurrentRoute(route){
      return this.$route.params.invoiceCategory === CONSTANTS.INVOICES_TAB_ROUTES.ALL_INVOICES || this.$route.params.invoiceCategory === route || this.$route.name === 'Filtered POs'
    },
    updateInvoicesFilteredList(event) {
      this.componentKey++
      this.invoicesFilteredList = event
    },
    updateFiltersSelected(filtersSelected) {
      this.invoicesFiltersSelected = filtersSelected
    },
    clearInvoiceFilters() {
      if(this.$refs && this.$refs.invoiceFilters) {
        this.$refs.invoiceFilters.clearFilters()
      }
    },
    async initializeComponent() {
      this.invoiceDashboardIsLoading = true;
      if(Object.keys(this.invoicesTableUserPreferences).length === 0) {
        this.resetInvoiceTableUserPreferences()
      }
      if ((!this.isAPAdmin || !this.viewingAPUserDataFor)){
        await this.getInvoiceDashboardData()
      }
      this.invoiceDashboardIsLoading = false
    },
    async resetViewAndGetInvoices() {
      await this.clickToViewYourInvoicesPO()
      this.clearInvoiceFilters()
    },
    showWarningForCopy(data) {
      swal
          .fire({
            title: `Warning`,
            focusConfirm: false,
            showCancelButton: true,
            html: `Please note that bank information and attachments for invoices would not be copied.`,
            footer:
                `<span class="text-muted swal-footer-text">Click on continue to proceed</span>`,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            allowOutsideClick: true,
            customClass: {
              confirmButton: "btn submit-btn flat-btn mt-2 mt-xl-0 ml-xl-2",
              cancelButton: "btn flat-btn gray-btn close-btn ml-2 my-3"
            },
            reverseButtons: true,
            buttonsStyling: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              data.row.docType === this.poBasedFormType ?
                  this.$router.push({ name: CONSTANTS.COPY_PO_BASED_PAYMENT_FORM, params: { docId: data.row.docId } }) : this.$router.push({ name: CONSTANTS.COPY_NON_PO_BASED_PAYMENT_FORM, params: { docId: data.row.docId } })
              this.$hhMixpanel.trackEvent(`Supplier Central - Copy was clicked for Invoice Number - ${data.row.invoiceNumber}`)
            }
          })
    },
    copyInvoiceData(data){
      if(this.isDataFromPOComponent)
        this.$emit('onRouteToInvoiceModal')

      this.showWarningForCopy(data)
    },
    setDataFromPOComponent() {
      let isDataFromPOComponent = this.invoices && this.invoices.length > 0
      this.isDataFromPOComponent = isDataFromPOComponent
      this.$set(this.columns[0], 'hidden', isDataFromPOComponent)
    },
    userSortClicked() {
      if(!this.isDataFromPOComponent) {
        this.invoicesTableUserPreferences.userClickedSort = true
        this.invoicesTableUserPreferences.showClearFilters = true
        this.setInvoicesTableUserPreferences(this.invoicesTableUserPreferences)
      }
      this.initializeTooltip();
    },
    onPageChange(params) {
      if(!this.isDataFromPOComponent) {
        this.invoicesTableUserPreferences.pagination.currentPage = params.currentPage
        this.invoicesTableUserPreferences.pagination.currentPerPage = params.currentPerPage
        this.invoicesTableUserPreferences.showClearFilters = true
        this.setInvoicesTableUserPreferences(this.invoicesTableUserPreferences)
      }
      this.initializeTooltip();
    },

   /*
   onSortChange method:
    vue-good-table emits onSortChange on route changes, so when we open modal, this method is autoInvoked
    the way we detect if user actually hit the sort buttons is via the userSortClicked method, and we persist it in store.
    If user did not click sort, user did not hit sort method and so we can pick last page from store
    If user manually sorted we reset current page in below method to 1 based on vgt functionality.
    */
    onSortChange(params) {
      if(!this.isDataFromPOComponent) {
        this.invoicesTableUserPreferences.sort.field = params[0].field
        this.invoicesTableUserPreferences.sort.type = params[0].type

        if(this.invoicesTableUserPreferences.userClickedSort) {
          this.invoicesTableUserPreferences.pagination.currentPage = 1
          this.invoicesTableUserPreferences.showClearFilters = true
        }
        this.invoicesTableUserPreferences.userClickedSort = false
        this.setInvoicesTableUserPreferences(this.invoicesTableUserPreferences)
      }
      this.initializeTooltip();
    },
    onPerPageChange(params) {
      if(!this.isDataFromPOComponent) {
        this.invoicesTableUserPreferences.pagination.currentPage = params.currentPage
        this.invoicesTableUserPreferences.pagination.currentPerPage = params.currentPerPage
        this.invoicesTableUserPreferences.showClearFilters = true
        this.currentPage = params.currentPage
        this.setInvoicesTableUserPreferences(this.invoicesTableUserPreferences)
      }
      this.initializeTooltip();
    },
    onPOClicked(po) {
      this.setPreviousRoute()
      if(this.$route.params) {
        //check if we're already on the same route, if we are - do nothing
        //this prevents navigationDuplicatedException in console.
        if(this.$route.params.value!==po)
          this.$router.push({ name: 'Filtered POs', params: {key: 'poNumber', value: po }})
      } else {
        this.$router.push({ name: 'Filtered POs', params: {key: 'poNumber', value: po }})
      }
    },
    setPreviousRoute() {
      if(this.$route.meta.tab === CONSTANTS.INVOICES_TABLE_ROUTE) {
        this.setPrevRoute(this.$route.fullPath)
      }
    },
    onInvoiceClicked(invoice){

      if(invoice && invoice.row)
        invoice= invoice.row

      this.setPreviousRoute()

      let params = {
        'invoiceNumber': CONSTANTS.INVOICE_MODAL_PARAMS.INVOICE_NUMBER_FIELD,
        'invoiceValue': invoice.invoiceNumber,
        'docId': CONSTANTS.INVOICE_MODAL_PARAMS.DOC_ID_FIELD,
        'docIdValue': invoice.docId
      }

      if(this.isDataFromPOComponent) {
        this.$emit('onRouteToInvoiceModal')
      }

      this.$router.push({ name: 'Filtered Invoices', params: params })

    },
    initializeTooltip() {
      setTimeout(() => {
        //eslint-disable-next-line
        $('[data-toggle="tooltip"]').tooltip() }, 300)
    },
    async getInvoiceDashboardData() {
      if(!this.formattedInvoices || this.formattedInvoices.length===0 || this.isInvoicesAndDraftsCached){
        await this.fetchInvoiceDashboardData();
      }

      this.initializeTooltip()

      if(this.invoicesTableUserPreferences.pagination.currentPage > 1 && !this.invoices) {
        await this.waitForPaginationRender()
      }

      if(this.$route.params && this.$route.params.invoiceNumber && this.$route.params.invoiceValue && this.$route.params.docId && this.$route.params.docIdValue  ) {
        this.showFilteredData()
      }
    }
  }
}
</script>

<style>
.header{
  display: flex;
  align-items: center;
}

.admin-title{
  border: none;
  outline: none;
  background: none;
  margin-left: 20px;
  margin-bottom: 9px;
  font-weight: bold;
  font-size: 14px;
  color: #0696d7;
  padding-top: 2px;
  font-family: artifaktElementRegular !important;
}
.table-data-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.invoice-tab-table-container{
  background-color: #fff;
  padding:10px 15px;
  min-height: 150px;
}

.po-modal-title {
  font-size: 22px;
  color: #000;
  font-family: artifaktElementBold !important;
}
</style>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>